import JwtDecode from 'jwt-decode';

export function signOut() {
  localStorage.removeItem('token');
}

export function isSignedIn() {
  const token = localStorage.getItem('token');

  if (!token) { return false; }

  try {
    const { exp: expiration } = JwtDecode(token);
    const isExpired = !!expiration && Date.now() > expiration * 1000;

    if (isExpired) { return false; }

    return true;
  } catch (_) {
    return false;
  }
}
